import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import styled from 'styled-components';

interface DrawerHeaderProps {
  title?: string;
  handleResetFilter?: () => void;
}

const DrawerHeader = ({ title, handleResetFilter }: DrawerHeaderProps) => {
  const { locale } = useRouter();

  const { t } = useTranslation('cityscape');

  return (
    <Container locale={locale}>
      {title && <span>{t(title)}</span>}

      <button onClick={handleResetFilter}>{t('reset')}</button>
    </Container>
  );
};

const Container = styled.div<{ locale: string | undefined }>`
  width: 100%;
  display: flex;
  flex-direction: ${props => (props.locale === 'ar' ? 'row-reverse' : 'row')};
  align-items: center;
  justify-content: space-between;

  span {
    color: #1a2028;
    font-family: materialBold;
    font-size: 21px;
  }

  button {
    background: white;
    border: none;
    text-decoration: underline;
    color: #1e6dac;
    font-family: materialRegular;
    font-size: 11px;
  }
`;

export default DrawerHeader;
